import { dateTime } from '@/_shared';

import type { TCouponModelData } from './coupon-model-data';
import { calcStartPaymentDateAndLimits } from './dates-calculations';
import { type TPaymentMethodType, type TSplitPayment, type TSubscriptionType } from './types';

const today = dateTime.now().toISOString();

const todayPlusOneMonth = dateTime.add(today, 1, 'month');
const currentMonth = dateTime.now().format('MM / YY');

const { recurringPaymentStartDate, recurringPaymentDateLimits } = calcStartPaymentDateAndLimits(today, 'monthly');

export const dummyCreditCard = {
  chargeAmount: '0',
  cardHolderName: '',
  cardNumber: '',
  expiryDate: currentMonth,
  cvvNumber: '',
  completeDate: todayPlusOneMonth.toISOString(),
};

export const investmentStateModel = {
  selectedPrepCourseIds: [] as string[],
  selectedAddonCourseIds: [] as string[],
  selectedOdtCourseIds: [] as string[],
  selectedFundamentalCourseIds: [] as string[],
};

export const paymentOptionsStateModel = {
  subscriptionType: 'monthly' as TSubscriptionType,
  paymentTerm: 0,
  discountPercentage: 0,
  wantToPayDownPayment: '',

  hasDiscountModeProcessInitialized: false,

  isMatchupShown: false,

  /** obsolete */

  coupons: [] as TCouponModelData,

  /** obsolete */

  minDownPayment: 0,
  recurringPaymentStartDate,
  recurringPaymentDateLimits,
  splitPayments: [] as TSplitPayment[],
  isPaymentSplitOpen: false,
};

export const checkoutStateModel = {
  password: '',

  softCreditPull: true,
  smsConsent: true,
  isTermsOpen: false,
  firstName: '',
  lastName: '',
  social_security_number: '',
  email: '',
  phone: '',
  state: '',

  termsAccepted: '' as 'YES' | 'NO' | '',
  termsAcceptanceTimeStamp: '',

  paymentProcessed: false,
  paymentProcessingTimeStamp: '',

  customerSyncCompleted: false,
  hasReviewedTerms: false,
  termsReviewedByCustomer: false,
  syncDateStamp: '',

  recurringPaymentCard: 'primary' as 'primary' | 'alternate',
  payment_method_type: 'cc' as TPaymentMethodType,

  splitPifPayments: [] as TSplitPayment[],
  isPifPaymentSplitOpen: false,

  card_1: { ...dummyCreditCard },

  card_2: { ...dummyCreditCard },
  backup_card: { ...dummyCreditCard },

  ach: { name: '', number: '', confirm_number: '', routing_number: '', type: 'savi' as 'savi' | 'chec' },
};

export const auditLogModel = {
  termsSignedBy: 'representative' as 'customer' | 'representative',
  termsSubSections: [] as { isSigned: boolean; signedDate: string }[],
  termsReviewerSystemInformation: { ipAddress: '', userAgent: '' },
  termsReviewedAt: '',
  termsReviewedBy: 'representative' as 'customer' | 'representative',

  checkoutProcessedAt: '',
  checkoutProcessorSystemInformation: { ipAddress: '', userAgent: '' },

  termsAcceptedBy: 'representative' as 'customer' | 'representative',
  termsAcceptanceSystemInformation: { ipAddress: '', userAgent: '' },
  termsAcceptedAt: '',

  customerSubmissionDate: '',
  checkoutDate: '',
  customer: { ipAddress: '', userAgent: '' },
  representative: { ipAddress: '', userAgent: '' },

  logVersion: 2,
};

export const globalDataModel = {
  leadId: '',
  campusId: '',
  summaryId: '',
  link: '',
  timeStamp: '',

  version: 0,
  is_climb: false,

  isLocked: false,

  coupons: [] as TCouponModelData,
  investment: investmentStateModel,
  paymentOptions: paymentOptionsStateModel,
  persistPaymentOptions: paymentOptionsStateModel,
  checkout: checkoutStateModel,
  auditLog: auditLogModel,
  hasBeenProcessedWithDiscountCheckout: false,
  backup: '[]',
};

export type TGlobalDataModel = typeof globalDataModel;
export type TGlobalDataModelInvestment = typeof globalDataModel.investment;
export type TGlobalDataModelPaymentOptions = typeof globalDataModel.paymentOptions;
export type TGlobalDataModelCheckout = typeof globalDataModel.checkout;
export type TCreditCard = typeof globalDataModel.checkout.card_1;
export type TGlobalDataModelAuditLog = typeof globalDataModel.auditLog;
